import React from 'react';
import authRoles from 'app/auth/authRoles';
import Notification from './Notification';
import AddNotification from './AddNotification/AddNotification';

const NotificationConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/Notifications',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Notification />
				</React.Suspense>
			),
		},
		{
			path: '/AddNotifications',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddNotification />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default NotificationConfig;
